// --- NEW FILE: packages/api-client/src/services/analyticsService.ts ---

import { getApiClient } from '../../client'; // Your configured Axios/API client instance

// Define the payload for the /track-event endpoint
interface TrackEventPayload {
  event_type: string;
  properties: Record<string, any>;
}

// Define the payload for the /identify-user endpoint
interface IdentifyUserPayload {
  user_id: string; // The user's UUID as a string
  visitor_id: string;
}

/**
 * A service dedicated to making API calls to the user analytics endpoints.
 */
export const analyticsService = {
  /**
   * Sends a "fire-and-forget" event to the backend.
   * @param eventName The name of the event.
   * @param properties The enriched dictionary of event properties.
   */
  trackEvent: async (eventName: string, properties: Record<string, any>): Promise<void> => {
    // The backend's /user-analytics/track-event endpoint expects a body with
    // `event_type` and `properties`. We construct that here.
    const payload: TrackEventPayload = {
      event_type: eventName,
      properties: properties,
    };
    // We don't need the response, but we await the post to handle potential errors higher up if needed.
    await getApiClient().post('/user-analytics/track-event', payload);
  },

  /**
   * Sends a request to link an anonymous visitor ID to a user ID.
   * @param payload An object containing user_id and visitor_id.
   */
  identifyUser: async (payload: IdentifyUserPayload): Promise<void> => {
    // The /user-analytics/identify-user endpoint expects this exact payload.
    await getApiClient().post('/user-analytics/identify-user', payload);
  },
};